import { useAuth0 } from "@auth0/auth0-react";
import { useMutation } from "@tanstack/react-query";
import AuthorizationService from "services/authorization";
import {
  AcceptOtpCommand,
  ChangePasswordCommand,
  SendOtpCommand,
} from "util/authorization";
import { OtpDTO } from "entities/dto/AuthorizationDTO";

/**
 * Hook to send OTP for password change
 */
export function useSendOtp() {
  const auth0Context = useAuth0();

  return useMutation<
    ["success", OtpDTO] | ["error", string],
    Error,
    SendOtpCommand
  >({
    mutationFn: async (command) => {
      return AuthorizationService.sendOtp(auth0Context, command);
    },
  });
}

/**
 * Hook to accept OTP code
 */
export function useAcceptOtp() {
  const auth0Context = useAuth0();

  return useMutation<
    ["success", OtpDTO] | ["error", string],
    Error,
    AcceptOtpCommand
  >({
    mutationFn: async (command) => {
      return AuthorizationService.acceptOtp(auth0Context, command);
    },
  });
}

/**
 * Hook to change password after OTP verification
 */
export function useChangePassword() {
  const auth0Context = useAuth0();

  return useMutation<
    ["success", OtpDTO] | ["error", string],
    Error,
    ChangePasswordCommand
  >({
    mutationFn: async (command) => {
      return AuthorizationService.changePassword(auth0Context, command);
    },
  });
}
